export const defaultConfig = {
  url: 'https://het-veer-api.astecom.nl/api'
}



// WEBPACK FOOTER //
// ./src/js/config.js